var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardMasterDark = function SvgCardMasterDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 28,
    fill: "#fff",
    fillOpacity: 0.15,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M22.91 8.497h-6.247v11.006h6.246V8.497z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.06 14c0-2.236 1.07-4.22 2.716-5.503A7.184 7.184 0 0015.374 7c-3.946 0-7.139 3.13-7.139 7s3.193 7 7.139 7a7.184 7.184 0 004.402-1.497A6.941 6.941 0 0117.06 14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M31.337 14c0 3.87-3.193 7-7.139 7a7.184 7.184 0 01-4.402-1.497A6.912 6.912 0 0022.512 14c0-2.236-1.07-4.22-2.716-5.503A7.184 7.184 0 0124.198 7c3.946 0 7.139 3.15 7.139 7z"
  })));
};
export default SvgCardMasterDark;